import React, { Component } from 'react';
import axios from "axios";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import { Link } from 'react-router-dom';

import Loader from './utils/Loadersmall';

class Brands extends Component {

    constructor(props) {
        super(props);
        this.state = {
            brandsList:'',
            serviceCheck:false,
        }   
    }

    async componentDidMount() {
        const params = new URLSearchParams();
        try {
          const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/brands',params);
           let resVal=response.data;
        //    console.log(resVal);
            if(resVal.status==='success'){
                this.setState({brandsList:resVal.data});
                this.setState({serviceCheck:true});
            }else{
                NotificationManager.error(resVal.message);
                this.setState({serviceCheck:true});
            }
        } catch (error) {
          console.error(error);
        }
    }

    render() {

        if(this.state.serviceCheck===false)
        return (<Loader/>);

        return (

            <div class="ps-about">

                <div class="ps-about__content">
                    <section class="ps-about__project">
                        <div class="container">
                            
                        <h3 class="text-center">Available Brands</h3>

                        <div class="row brandBoxTop">
                                {(this.state.brandsList.length>0)?
                                    this.state.brandsList.map((data)=>{
                                        return(
                                            <>
                                                <div class="customeBrandNav">
                                                    <a href={`#${data.brand_index}`} class="customeBrandNavTitle">{data.brand_index}</a>
                                                </div>
                                            </>
                                        )
                                    })
                                :
                                  null
                                }
                        </div>

                        <div class="row">

                                {(this.state.brandsList.length>0)?
                                    this.state.brandsList.map((data)=>{
                                        return(
                                            <>
                                            <div class="col-12 col-md-12" id={data.brand_index}><h4 class="brandTitle">{data.brand_index}</h4></div>
                                            {data.brand_items.map((dataSub)=>{
                                                return(
                                                    <>
                                                        <div class="col-6 col-md-2"><Link class="brandName" to={`/products/brand/${Buffer.from(dataSub.brand_code).toString('base64')}/${dataSub.brand_name}`}>{dataSub.brand_name}</Link></div>
                                                    </>
                                                )
                                                })
                                            }
                                            </>

                                            )
                                    })
                                :
                                <>
                                    <p>No brands found</p>
                                </>
                                }

                            </div>
                        </div>
                    </section>
        
                </div>
            
            </div>
    
        );
    }
}

export default Brands;